import React from 'react';
import {
  Button,
  TableCell,
  TableRow
} from '@material-ui/core';


const MapCatalogTableRow = ({item, setSelectedItem}) => {
  const {
    catalogName,
    sku,
    revenueCategory1,
    revenueCategory2,
    manufacturer = '',
    catalogBrand = '',
    loyaltyProgram = ''
  } = item;

  return (
    <TableRow>
      <TableCell>
        {catalogName}
      </TableCell>
      <TableCell className="whitespace-no-wrap">
        {sku}
      </TableCell>
      <TableCell>
        {revenueCategory1}
      </TableCell>
      <TableCell>
        {revenueCategory2}
      </TableCell>
      <TableCell>
        {catalogBrand}
      </TableCell>
      <TableCell>
        {manufacturer}
      </TableCell>
      <TableCell>
        {loyaltyProgram}
      </TableCell>
      <TableCell align="center">
        <Button
          color="primary"
          variant="contained"
          className="uppercase text-12 font-bold"
          onClick={() => setSelectedItem(item)}
        >
          Select
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default MapCatalogTableRow;
